<template>
  <div class="product-list-container">
    <div class="product-list-item" @click.stop="productsDetails(item)" v-for="item in tableData" :key="item.uuid">
      <div class="product-image-section">
        <img
          class="product-image cursor-pointer"
          @click.stop="productsDetails(item)"
          :src="getImgUrl(item.images)"
          alt="商品图片"
        />
      </div>
      <div class="item-content" v-if="item && item.shows && item.shows.pcList">
        <div class="info-content">
          <div class="product-main-info">
            <div class="product-details">
              <div class="product-name-section">
                <div class="product-name cursor-pointer" @click.stop="productsDetails(item)">
                  <span
                    class="name-text"
                    :style="`-webkit-line-clamp: ${item.shows.pcList.length ? item.shows.pcList[0][0].row : 1};`"
                  >
                    {{ getGoodName(item) }}
                  </span>
                </div>
              </div>

              <div class="product-specs">
                <div class="specs-grid">
                  <div class="spec-item" v-for="(child, _idx) in item.shows.pcList[3]" :key="_idx">
                    <span class="spec-label" v-if="byTxtGetTitle(child.content)"
                      >{{ byTxtGetTitle(child.content) }}：</span
                    >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="byTxtGetValue(child.content)"
                      placement="top-start"
                    >
                      <span
                        class="spec-value line-wrap"
                        :style="`-webkit-line-clamp: ${getRows(_idx, item.shows.pcList[3]) || 1};`"
                        >{{ byTxtGetValue(child.content) }}</span
                      >
                    </el-tooltip>
                  </div>
                  <!-- <div class="spec-item">
                    <span class="spec-label">件号：</span>
                    <span class="spec-value">{{ item.code || "-" }}</span>
                  </div>
                  <div class="spec-item" v-if="item.productBatch !== undefined">
                    <span class="spec-label">生产批号：</span>
                    <span class="spec-value">{{ item.productBatch || "-" }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">规格：</span>
                    <span class="spec-value">{{ item.model || "-" }}</span>
                  </div>
                  <div class="spec-item">
                    <span class="spec-label">生产码：</span>
                    <span class="spec-value">{{ item.productionCode || "-" }}</span>
                  </div> -->
                </div>
                <!-- <div class="vehicle-compatibility">
                  <span class="compatibility-label">适用车型：</span>
                  <span class="compatibility-value">{{ item.vehModel || "-" }}</span>
                </div> -->
              </div>
            </div>
          </div>
          <div class="flex flex-row-center height-full warehouse">
            <div class="stock-info">
              <div class="warehouse-name" v-for="(child, _idx) in item.shows.pcList[1]" :key="_idx">
                <div class="line-wrap" :style="`-webkit-line-clamp: ${child.row || 1};`">
                  <span
                    class="minBuyQty"
                    v-if="child.content.includes('minBuyQty')"
                    v-html="getTagValue(child.content)"
                  ></span>
                  <span v-else v-html="getTagValue(child.content)"></span>
                </div>
              </div>
              <!-- <div class="stock-qty">库存: {{ item.qty }}</div> -->
            </div>
          </div>
          <div class="stock-price-section">
            <div class="pricing-info">
              <div v-for="(child, _idx) in item.shows.pcList[2]" :key="_idx">
                <div class="line-wrap" :style="`-webkit-line-clamp: ${child.row || 1};text-align:center`">
                  <span class="price" v-html="getTagValue(child.content)"></span>
                  <span class="price-unit" v-show="item.unit && child.content.includes('<price>')"
                    >/{{ item.unit }}</span
                  >
                  <!-- <span class="price-container">
                  </span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="product-secondary-info">
            <div class="product-controls">
              <div @click.stop="e => e.stopPropagation()" @dblclick="e => e.stopPropagation()">
                <div class="control-header">
                  <div class="header-left" v-if="item.extaCode">
                    <!-- <span v-if="Number(item.minBuyQty) > 1" class="min-order">起订量：{{ item.minBuyQty }}</span> -->
                    <span v-if="Number(item.cartQty) > 0" class="min-order">已添加：{{ item.cartQty }}</span>
                  </div>
                  <template v-else>
                    <!-- <span v-if="Number(item.minBuyQty) > 1" class="min-order">起订量：{{ item.minBuyQty }}</span> -->
                    <span v-if="Number(item.cartQty) > 0" class="min-order">已添加：{{ item.cartQty }}</span>
                  </template>
                  <span
                    v-if="item.extaCode"
                    class="exchange-link cursor-pointer"
                    @click.stop="productsDetails(item, true)"
                  >
                    互换>>
                  </span>
                </div>

                <div class="cart-control" @click.stop>
                  <template v-if="item.cartQty > 0">
                    <ControlDisabledInput
                      v-if="isMoreModelFn(item)"
                      :model-value="item.orderQuantity"
                      :disabled="item.status !== 3"
                      @changeNum="() => openProductDetails(item)"
                    ></ControlDisabledInput>
                    <ControlInput
                      v-else
                      :model-value="item.orderQuantity"
                      :min="0"
                      :min-value="Number(item.minQty)"
                      @crearValue="n => clearNum(item)"
                      :step="Number(item.uQty)"
                      :disabled="item.status !== 3"
                      @change="n => changeQty(item, n)"
                    ></ControlInput>
                    <span class="unit">{{ item.unit }}</span>
                  </template>
                  <div
                    v-else
                    :class="{ 'add-to-cart-btn': true, 'disabled-btn': item.status !== 3 }"
                    @click.stop="isMoreModelFn(item) ? openProductDetails(item) : addShoppingCartFun(item, true)"
                  >
                    <div class="cart-icon-wrapper">
                      <i class="fas fa-shopping-cart"></i>
                    </div>
                    <span class="cart-text">加入购物车</span>
                  </div>
                </div>
                <div style="text-align: center;">
                  <span v-if="item.limits?.limit" class="limit-text">{{ item.limits?.limit }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-tags">
          <div class="tags-container">
            <span class="tag coupon" v-for="coupon in couponList(item.coupons)" :key="coupon.id">
              <span class="coupon-icon">券</span>
              {{ coupon.title }}
            </span>
            <span v-show="item.extaCode" class="tag exchange cursor-pointer" @click.stop="productsDetails(item, true)">
              互换
            </span>
            <!-- <span v-show="item.promotion" class="tag promotion">
              促销
            </span> -->
            <span v-if="item.promotion" class="tag promotion">{{ item.promotion }}</span>
            <!-- <span v-show="item.limitString" class="tag new">
              限购
            </span> -->
            <span v-if="item.limits?.rule" class="tag new">{{ item.limits?.rule }}</span>
          </div>
        </div>
      </div>
    </div>

    <ProductsDetailsBox @refreshList="refreshList" ref="productsDetailsBox" />
  </div>
</template>

<script>
import ProductsDetailsBox from "@/components/ProductsDetailsBox";
import ControlInput from "../products/components/ControlInput.vue";
import ControlDisabledInput from "../products/components/ControlDisabledInput.vue";
import shoppingCartBtn from "@/assets/img/newProducts/shoppingCart-btn.svg";
import { addShoppingCart } from "@/api/shoppingCart/index.js";
import deafultProduct from "@/assets/img/newProducts/deafultProduct.png";
import { extractTagContent, byTxtGetTitle, byTxtGetValue } from "@/views/newProducts/minin/homepage.js";
import { deleteShoppingCart } from "@/api/shoppingCart/index.js";
import { mapState } from "vuex";

export default {
  components: {
    ControlInput,
    ControlDisabledInput,
    ProductsDetailsBox
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState("goods", {
      goodNameRules: state => {
        return state.goodNameRules;
      }
    }),
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    })
  },
  watch: {
    list: {
      handler(newV) {
        this.tableData = newV;
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      tableData: [],
      shoppingCartBtn,
      deafultProduct
    };
  },
  methods: {
    getRows(index, list) {
      const num = index % 3;
      if (num === 0) {
        const row1 = list[index].row;
        const row2 = list[index + 1] ? list[index + 1].row : 1;
        const row3 = list[index + 2] ? list[index + 2].row : 1;
        const arr = [row1, row2, row3];
        const max = Math.max(...arr);
        return max;
      }
      if (num === 1) {
        const row2 = list[index - 1] ? list[index - 1].row : 1;
        const row1 = list[index].row;
        const row3 = list[index + 1] ? list[index + 1].row : 1;
        const arr = [row1, row2, row3];
        const max = Math.max(...arr);
        return max;
      }
      if (num === 2) {
        const row2 = list[index - 1] ? list[index - 1].row : 1;
        const row3 = list[index - 2] ? list[index - 2].row : 1;
        const row1 = list[index].row;
        const arr = [row1, row2, row3];
        const max = Math.max(...arr);
        return max;
      }
    },
    getTagValue(str) {
      return extractTagContent(str);
    },
    byTxtGetTitle(str) {
      return byTxtGetTitle(str);
    },
    byTxtGetValue(str) {
      return byTxtGetValue(str);
    },
    getGoodName(item) {
      console.log("item", item);
      const list = item.shows?.pcList;
      console.log("list", list);
      if (list && list.length) {
        return list[0][0].content;
      }
      return "";
      // return getGoodsName(this.goodNameRules, item);
    },
    getBrandQualityPlaceName(item) {
      const names = [];
      if (item.brand) {
        names.push(item.brand);
      }
      if (item.insurCertType) {
        names.push(item.insurCertType);
      }
      if (item.productionPlace) {
        names.push(item.productionPlace);
      }
      return names.join("|");
    },
    couponList(list) {
      if (list && list.length > 0) {
        return list;
      }
      return [];
    },
    productsDetails(item, showExchange) {
      if (item.status !== 3) {
        return;
      }
      if (showExchange) {
        item.showExchange = true;
      } else {
        if (item.showExchange) {
          delete item.showExchange;
        }
      }
      this.$router.push({
        path: "/new-products/product-details",
        query: {
          data: encodeURIComponent(JSON.stringify(item))
        }
      });
    },
    refreshList() {
      this.$emit("refresh");
    },
    //添加到购物车
    async addShoppingCartFun(row, flag) {
      if (row.status !== 3) {
        return;
      }
      if (!this.userInfo.userId) {
        this.$router.push({ path: "/login" });
        return;
      }
      const cartQty = Number(row.cartQty) || row.orderQuantity || 1;
      const data = [
        {
          goodsType: row.type, // 商品类型，0:普通，1:补货，2:促销组合，3:服务项目，4:套餐
          goodsId: row.id, // 商品ID
          code: row.code, // 商品编码
          name: row.name, // 商品名称
          property: row.property, // 商品性质
          warehouse: row.warehouse, // 仓库
          productBatch: row.productBatch, // 生产批号
          price: !isNaN(Number(row.price)) ? row.price : "0", // 加购时价格
          qty: String(cartQty), // 数量
          remarks: row.remarks, // 备注
          checked: false, // 是否已选择
          areaDetailId: 0 // 商城区域详情ID，用来实时关联修理厂用
        }
      ];
      try {
        await addShoppingCart({ cover: true, data: data });
        if (flag) {
          this.$message.success("已成功加入购物车");
        } else {
          this.$message.success("修改购物车数量成功");
        }
        await this.$bus.$emit("shoppingCartRefresh");
        await this.$emit("refresh");
      } catch (error) {
        this.$message.error(error.message || "添加失败");
      }
    },
    openProductDetails(row) {
      if (row.status !== 3) {
        return;
      }
      if (!this.userInfo.userId) {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$refs.productsDetailsBox.show(row);
    },
    getImgUrl(imgList) {
      if (imgList && imgList.length > 0) {
        return imgList[0];
      }
      return this.deafultProduct;
    },
    changeQty(item, n) {
      item.cartQty = n;
      this.addShoppingCartFun(item);
    },
    //删除
    clearNum(item) {
      this.$confirm("确认从购物车删除该商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteCartItem(item);
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteCartItem(row) {
      try {
        await deleteShoppingCart({ ids: [row.cartId] });
        this.$message.success("删除成功");
        await this.$bus.$emit("shoppingCartRefresh");
        await this.$emit("refresh");
      } catch (error) {
        this.$message.error("删除失败," + error.message);
      }
    },
    // 是否是多规格
    isMoreModelFn(row) {
      return !!row.isSpecification;
    },
    // 格式化单个价格
    formatSinglePrice(priceStr) {
      if (!priceStr) return [];
      const parts = priceStr.split(".");
      const result = [];
      result.push({ type: "icon", content: "￥" });
      result.push({ type: "integer", content: parts[0] });
      if (parts.length > 1) {
        result.push({ type: "decimal", content: "." + parts[1] });
      } else {
        result.push({ type: "decimal", content: ".00" });
      }
      return result;
    },
    // 格式化价格
    formatPrice(price) {
      if (!price) return [];

      if (price.includes("~")) {
        const [minPrice, maxPrice] = price.split("~");
        const minParts = this.formatSinglePrice(minPrice);
        const maxParts = this.formatSinglePrice(maxPrice);
        return [...minParts, { type: "separator", content: " ~ " }, ...maxParts];
      }

      if (price.includes("起")) {
        const [pricePart] = price.split("起");
        const priceParts = this.formatSinglePrice(pricePart);
        return [...priceParts, { type: "suffix", content: "起" }];
      }

      if (!isNaN(Number(price))) {
        return this.formatSinglePrice(price);
      }

      return [];
    },
    // 获取价格部分的样式类
    getPriceClass(type) {
      switch (type) {
        case "icon":
          return "price-icon";
        case "integer":
          return "price-integer";
        case "decimal":
        case "suffix":
        case "separator":
          return "price-decimal";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list-container {
  // background-color: #f8f9fa;
  // padding: 2px;
}

.product-list-item {
  background: #fff;
  // border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  // margin-bottom: 12px;
  border-bottom: 1px solid #eaeaea;
  transition: all 0.2s ease;
  overflow: hidden;
  display: flex;
  padding: 8px;
  gap: 16px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
}

.item-content {
  flex: 1;
}
.info-content {
  display: flex;
  justify-content: space-between;

  gap: 16px;
  align-items: center;
}
.warehouse {
  width: 100px;
  flex-shrink: 0;
  justify-content: center;
}
.product-main-info {
  display: flex;
  // flex: 1;
  width: calc(100% - 540px);
  overflow: hidden;
  flex-shrink: 0;
  gap: 12px;
  min-height: 100px;
}

.product-image-section {
  flex-shrink: 0;

  .product-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.03);
    }
  }
}

.product-details {
  // flex: 1;
  // width: calc(100% - 92px);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-name-section {
  .product-name {
    .name-text {
      font-size: 16px;
      font-weight: 700;
      color: #1a1a1a;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
    }
  }
}

.product-specs {
  margin: 4px 0;
  width: 100%;
  .specs-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 1px;
    flex: 1;
    padding-right: 4px;
    & > div {
      width: 33%;
    }
    & :last-child {
      flex: 1;
      width: auto;
    }
    .spec-item {
      display: flex;
      // align-items: center;
      .spec-label {
        font-size: 12px;
        color: #666;
        white-space: nowrap;
        flex-shrink: 0;
        // width: 66px;
        text-align: left;
      }

      .spec-value {
        // max-width: 120px;
        // min-width: 165px;
        // flex: 1;
        // max-width: calc(100% - 66px);
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        font-size: 12px;
        color: #333;
        font-weight: 500;
      }
    }
  }
  .vehicle-compatibility {
    display: flex;
    align-items: center;
    margin-top: 8px;

    .compatibility-label {
      font-size: 12px;
      color: #666;
      white-space: nowrap;
      flex-shrink: 0;
      width: 66px;
      text-align: right;
    }

    .compatibility-value {
      max-width: 560px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      color: #333;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.product-tags {
  margin-top: 2px;

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }
}
.promotion-text,
.limit-text {
  font-size: 11px;
  color: #e84f47;
  font-weight: 500;
}

.product-secondary-info {
  flex-shrink: 0;
  width: 180px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stock-price-section {
  flex-shrink: 0;
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stock-info {
  text-align: center;
  padding: 8px;
  border-radius: 6px;

  .warehouse-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 4px;
  }

  .stock-qty {
    font-size: 14px;
    color: #666;
  }
}

.pricing-info {
  text-align: center;

  .price-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 2px;
  }
  .price-container {
    display: flex;
    align-items: baseline;

    .price-icon {
      font-size: 14px;
      color: #e84f47;
      font-weight: 600;
    }

    .price-integer {
      font-size: 22px;
      color: #e84f47;
      font-weight: 700;
      margin-left: 2px;
    }

    .price-decimal {
      font-size: 14px;
      color: #e84f47;
      font-weight: 600;
    }

    .price-unit {
      color: #999;
      font-weight: 400;
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .current-price {
    font-size: 16px;
    font-weight: 700;
    color: #e84f47;
  }

  .last-price {
    font-size: 11px;
    color: #e84f47;
    font-weight: 500;
  }
}
.min-order {
  font-size: 11px;
  color: #e84f47;
  font-weight: 500;
}
.product-controls {
  .control-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    column-gap: 12px;
    .header-left {
      display: flex;
      flex-direction: column;
      row-gap: 4px;
    }

    .exchange-link {
      font-size: 12px;
      color: var(--color-primary);
      font-weight: 500;
      transition: color 0.2s ease;

      &:hover {
        color: var(--color-primary-dark10);
      }
    }
  }

  .cart-control {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    .add-to-cart-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 6px 12px;
      background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
      color: white;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 1px 3px rgba(238, 90, 36, 0.3);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(238, 90, 36, 0.4);
      }

      &:active {
        transform: translateY(0);
      }

      .cart-icon-wrapper {
        display: flex;
        align-items: center;

        i {
          font-size: 12px;
        }
      }

      .cart-text {
        font-size: 12px;
        font-weight: 500;
      }
    }
    .disabled-btn {
      background: #999;
      cursor: not-allowed;
      &:hover {
        transform: none;
        box-shadow: none;
      }
    }
    .unit {
      font-size: 12px;
      color: #666;
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}

@media (max-width: 1024px) {
  .item-content {
    flex-direction: column;
    padding: 12px;
  }

  .product-secondary-info {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .stock-price-section {
    flex-direction: row;
    gap: 16px;
  }

  .product-controls {
    width: auto;
  }
}
// @media (max-width: 1300px) {
//   .product-specs .specs-grid {
//     & > div {
//       width: calc(50% - 1px);
//     }
//   }
// }
@media (max-width: 768px) {
  .product-main-info {
    flex-direction: row;
  }

  .product-image-section {
    .product-image {
      width: 70px;
      height: 70px;
    }
  }

  .product-specs .specs-grid {
    grid-template-columns: 1fr;
    gap: 2px;
  }

  .product-secondary-info {
    flex-direction: column;
    gap: 10px;
  }

  .stock-price-section {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
